export default {"src":"/_next/static/media/question.c540ebd3.svg","height":336,"width":523,"blurWidth":0,"blurHeight":0};